import { BrandedTracking as BrandedTrackingModule } from 'common';
import React from 'react';

const { BrandedTracking } = BrandedTrackingModule;

const BrandedTrackingWrapper = props => (
	<div className="account-branded-tracking-wrapper">
		<BrandedTracking />
	</div>
);

export default BrandedTrackingWrapper;
